import React, { Component } from 'react';
import './style.css';
import {data} from './data.js';
import FaqsHeader from './faqHeader';



class Faq extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
     };
  }

  toggle = (i) => {
    if (this.state.selected === i) {
      this.setState({ selected: null });
    } else {
      this.setState({ selected: i });
    }
  };
    // console.log();
  render()
  {
    const { selected } = this.state;
    return (
      <div>
        <FaqsHeader>
        </FaqsHeader>

     
      <div className="wrapper">
        <div className="accordion">
          {data.map((item, i) => (
           <div className={`item ${selected === i ? 'open' : ''}`} key={i}>
           <div className="title" onClick={() => this.toggle(i)}>
             <h2>{item.question}</h2>
             <span>{selected === i ? '▼' : '►'}</span>
           </div>
              <div className={this.state.selected === i ? 'content show' : 'content'}>
                  {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    );
  }
}



export default Faq;


// WEBPACK FOOTER //
// ./src/views/pages/faqs/index.js